document.documentElement.classList.add('js');
const menuToggle = document.querySelector('.menu-toggle');
menuToggle?.addEventListener('click', () => {
  const open = menuToggle.getAttribute('aria-expanded') !== 'true';
  menuToggle.setAttribute('aria-expanded', String(open));
  document.querySelector('.site-header').classList.toggle('menu-open', open);
  document.body.classList.toggle('menu-open', open);
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.nav-group[open]').forEach(group => { group.open = false; group.querySelector('summary').focus(); });
  if (menuToggle?.getAttribute('aria-expanded') === 'true') { menuToggle.click(); menuToggle.focus(); }
});

document.addEventListener('click', (event) => {
  const header = document.querySelector('.site-header');
  if (!header?.contains(event.target)) {
    document.querySelectorAll('.nav-group[open]').forEach(group => { group.open = false; });
    if (menuToggle?.getAttribute('aria-expanded') === 'true') menuToggle.click();
  }
});
document.querySelectorAll('.nav-group').forEach(group => group.addEventListener('toggle', () => {
  if (group.open) document.querySelectorAll('.nav-group').forEach(other => { if (other !== group) other.open = false; });
}));

document.querySelector('.site-header')?.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab' || menuToggle?.getAttribute('aria-expanded') !== 'true') return;
  const controls = [...event.currentTarget.querySelectorAll('a, button, summary')].filter(control => control.getClientRects().length);
  const first = controls[0];
  const last = controls[controls.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
});
window.matchMedia('(min-width: 1025px)').addEventListener('change', event => {
  if (event.matches && menuToggle?.getAttribute('aria-expanded') === 'true') menuToggle.click();
});

